import { gql } from '@apollo/client';

export const CredentialTypeBasicFieldsFragment = gql`
  fragment CredentialTypeBasicFieldsFragment on CredentialType {
    id
    displayName
    value
  }
`;

export const GroupingBasicFieldsFragment = gql`
  fragment GroupingBasicFieldsFragment on Grouping {
    id
    name
    universityName
    programs
  }
`;
